
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, LineChart, PieChart } from "lucide-react";

export function EmailAnalyticsDemo() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row gap-4">
        <Card className="flex-1">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium">Email Open Rate</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-between">
              <div className="text-2xl font-bold">76.2%</div>
              <BarChart className="h-4 w-4 text-primary" />
            </div>
            <p className="text-xs text-muted-foreground mt-1">
              +5.4% from last month
            </p>
          </CardContent>
        </Card>
        <Card className="flex-1">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium">Click Rate</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-between">
              <div className="text-2xl font-bold">24.8%</div>
              <LineChart className="h-4 w-4 text-primary" />
            </div>
            <p className="text-xs text-muted-foreground mt-1">
              +2.1% from last month
            </p>
          </CardContent>
        </Card>
        <Card className="flex-1">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium">Delivery Rate</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-between">
              <div className="text-2xl font-bold">98.9%</div>
              <PieChart className="h-4 w-4 text-primary" />
            </div>
            <p className="text-xs text-muted-foreground mt-1">
              +0.2% from last month
            </p>
          </CardContent>
        </Card>
      </div>
      
      <Card>
        <CardHeader>
          <CardTitle>Email Analytics Benefits</CardTitle>
        </CardHeader>
        <CardContent className="text-sm space-y-2">
          <p className="flex items-baseline gap-2">
            <span className="inline-block w-3 h-3 rounded-full bg-primary"></span>
            <strong>Open tracking</strong>: Monitor which emails get opened and by whom
          </p>
          <p className="flex items-baseline gap-2">
            <span className="inline-block w-3 h-3 rounded-full bg-green-500"></span>
            <strong>Click tracking</strong>: See which links receive engagement
          </p>
          <p className="flex items-baseline gap-2">
            <span className="inline-block w-3 h-3 rounded-full bg-amber-500"></span>
            <strong>Delivery monitoring</strong>: Ensure emails reach their destination
          </p>
          <p className="flex items-baseline gap-2">
            <span className="inline-block w-3 h-3 rounded-full bg-blue-500"></span>
            <strong>Performance by template</strong>: Compare effectiveness of different email types
          </p>
          <p className="text-xs text-muted-foreground italic mt-2">
            Note: This is a demonstration of the analytics capabilities. Visit the Resend dashboard to view actual analytics.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
